import { render, staticRenderFns } from "./ModifyIndustrialPropertyForm.vue?vue&type=template&id=3bbb9816"
import script from "./ModifyIndustrialPropertyForm.vue?vue&type=script&lang=js"
export * from "./ModifyIndustrialPropertyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports